import { AppLangCode } from '@libs/types';
export const enFonts = {
    primaryRegular: 'Satoshi-regular',
    primary: 'Satoshi-medium',
    primaryMedium: 'Satoshi-medium',
    primaryBold: 'Satoshi-bold',
};
export const kaFonts = {
    primaryRegular: 'Firago-regular',
    primary: 'Firago-regular',
    primaryMedium: 'Firago-regular',
    primaryBold: 'Firago-medium',
};
export const cyrillicFonts = {
    primaryRegular: 'TT-Hoves-Pro-regular',
    primary: 'TT-Hoves-Pro-regular',
    primaryMedium: 'TT-Hoves-Pro-medium',
    primaryBold: 'TT-Hoves-Pro-bold',
};
export const fontsByLang = {
    [AppLangCode.KA]: kaFonts,
    [AppLangCode.RU]: cyrillicFonts,
    [AppLangCode.UA]: cyrillicFonts,
    [AppLangCode.EN]: enFonts,
};
export default enFonts;
//# sourceMappingURL=fonts.js.map